import api from "../store/services/api";

export const getAddressLatLng = async (
  street,
  houseNumber,
  neighborhood,
  city
) => {
  try {
    const res = await api.get(
      `/latlng?street=${street}&house_number=${houseNumber}&neighborhood=${neighborhood}&city=${city}`
    );
    const { latitude, longitude } = res.data;

    return {
      lat: latitude,
      lng: longitude,
    };
  } catch (e) {
    throw e;
  }
};
